import React, { ReactNode } from "react";
import { Patient } from "../../system/AppState/AppPatientsState";
import ScaffoldTitle from "../Scaffold/components/ScaffoldTitle";
import Scaffold from "../Scaffold/Scaffold";

interface Props {
  patient: Patient;
  title: string;
  extraHeader: ReactNode;
  visitsAndTasksList: ReactNode;
  onClickGoBack: () => void;
}

const PatientVisitsAndTasksScreen = (props: Props) => {
  return (
    <Scaffold
      title={<ScaffoldTitle label={props.title} />}
      extraHeader={props.extraHeader}
      onClickGoBack={props.onClickGoBack}
    >
      {props.visitsAndTasksList}
    </Scaffold>
  );
};

export default React.memo(PatientVisitsAndTasksScreen);
